import React from "react";
import {Colors, Container, IconAlert, Text} from "../../../../ui";
import {Link} from "../../../bounce-ui";

const BannerStyle = {
  backgroundColor: Colors.tertiary._200,
  top: 0,
  left: 0,
  right: 0,
  height: "110px",
  width: "100%",
  textAlign: "center",
  padding: "18px 25px",
};

interface ITemporaryPlanNotice {
  isInterimPlan: boolean;
  showEndPlanBanner: boolean;
  daysUntilPlanEnds?: number;
  handleClick?: () => void;
}

export const TemporaryPlanNotice = ({
  isInterimPlan,
  showEndPlanBanner,
  daysUntilPlanEnds,
  handleClick,
}: ITemporaryPlanNotice) => {
  if (!isInterimPlan || !showEndPlanBanner || !daysUntilPlanEnds) {
    return null;
  }

  return (
    <Container sx={BannerStyle}>
      <IconAlert color={Colors.orange._800} />
      <Container sx={{gap: "2px"}}>
        <Text size={14} variant={"inter500"}>
          {`This relief program ends in ${daysUntilPlanEnds} days`}
        </Text>
        <Link size={14} onClick={() => handleClick?.()}>
          Switch to a full plan
        </Link>
      </Container>
    </Container>
  );
};
